import { StyleSheet } from 'aphrodite/no-important';
import { mixins } from 'consumer-components';
import * as deploymentConfig from 'login-utils/deploymentConfig';

const GLOBALS = '__GLOBAL_STYLES__';

const globalExtension = {
  selectorHandler: (selector, baseSelector, generateSubtreeStyles) =>
    baseSelector.includes(GLOBALS) ? generateSubtreeStyles(selector) : null,
};

const actionColor = deploymentConfig.getOrganizationColors().action;
// .extend currently isn't included in the Aphrodite types, and adding it is actually
// really tricky because it returns effectively a new copy of the entire Aphrodite API,
// which is hard to type without a lot of duplication.
const extended = (StyleSheet as any).extend([globalExtension]);

/**
 * These styles are globally applied across the app, although are no-importanted
 * so they can be overridden by any more explicit style.
 *
 * This pattern was taken from https://github.com/Khan/aphrodite/issues/139#issuecomment-266500624.
 */

const styles = extended.StyleSheet.create({
  [GLOBALS]: {
    a: {
      color: actionColor,
    },
    // Below colors are for Lottie loading animations only
    '.actionColor path': {
      fill: actionColor,
      stroke: actionColor,
    },
    '.actionAccent_light path': {
      fill: mixins.lighten(actionColor, 0.5),
    },
    '.actionAccent_lighter path': {
      fill: mixins.lighten(actionColor, 0.5),
    },
    '.actionAccent_dark path': {
      fill: mixins.lighten(mixins.desaturate(actionColor, 0.3), 0.2),
    },
    '.actionAccent path': {
      fill: mixins.lighten(actionColor, 0.5),
    },
  },
});

export default extended.css(styles[GLOBALS]);
